import { call, put, takeLatest } from "redux-saga/effects";
import { delay } from "redux-saga";
import { history } from "../store";
import actions from "../actions/actionTypes";
import fetchSaga from "./fetchSaga";
import { apiRequestFailureAction, apiRequestSuccessAction } from "actions/requestActions";
import { showLoader, hideLoader } from "actions/soleraLoaderActions";
import { mapFeatures } from "mappers/preferences";

import { fetchChangeRole, fetchGhostingCompanies, fetchResetRole } from "./Api";

export function* changeRoleRequest(data) {
  yield put(showLoader());
  var companyId = data.payload;
  let messages = { messages: [] };
  if(companyId === ""){
    messages.messages.push({
      key: null,
      messageText: "Please select a Company to change the role",
      type: "warning"
    });
    yield put(apiRequestFailureAction(messages));
    yield put(hideLoader());
    return;
  }
  
  try {
    const data = yield call(fetchSaga, fetchChangeRole, {companyId});
    const features = yield call(mapFeatures, data.preferences);
    yield put({ type: actions.SET_APP_FEATURES, payload: features });
    yield put({ type: actions.SET_PREFERENCES, payload: data.preferences });
    yield put({ type: actions.SET_GHOSTING_COMPANY, payload: companyId });
    yield put({ type: actions.IS_GHOSTING, payload: true });
    history.push("/");
  } catch (err) {
    console.log("Error getting preferences: ", err);
  }

  yield put(hideLoader());
}

export function* loadGhostingCompanies() {
  yield put(showLoader());
  const data = yield call(fetchSaga, fetchGhostingCompanies);
  yield put({ type: actions.SET_GHOSTING_COMPANIES, payload: data });
  yield put(hideLoader());
}

export function* resetRoleRequest() {
  yield put(showLoader());
  const data = yield call(fetchSaga, fetchResetRole);
  yield put({ type: actions.IS_GHOSTING, payload: false });
  yield put({ type: actions.SET_GHOSTING_COMPANY, payload: "" });
  history.push("/");
  yield put(hideLoader());
}

export const changeRoleSagas = [
  takeLatest(actions.CHANGE_ROLE, changeRoleRequest),
  takeLatest(actions.GHOSTING_COMPANIES, loadGhostingCompanies),
  takeLatest(actions.RESET_ROLE, resetRoleRequest)
];